import { statsOnWidgetInteraction } from '../stats';
import { project } from '../initializeStats';

export const resizeAccordion = () => {
  // document.querySelectorAll('.gallery__accordion').forEach((el) => {
  //   el.querySelectorAll('.widget__item').forEach((item) => {
  //     const width = window.innerWidth > 768
  //       ? `${el.querySelector('.accordion__element_hover').getBoundingClientRect().width - el.querySelector('.accordion__element .accordion__title').getBoundingClientRect().width}px`
  //       : '100%';      
  //   });
  // });
};

export function accordion () {
  if (document.querySelectorAll('.gallery__accordion').length > 0) {
    //resizeAccordion();
    document.querySelectorAll('.gallery__accordion').forEach((slider) => {
      slider.querySelectorAll('.widget__item').forEach((el) => {
        el.addEventListener('mouseenter', () => {
          const ts = 400;
          if (!project.isScrollingFlag && !el.classList.contains('accordion__element_hover')) {
            slider.querySelectorAll('.widget__item').forEach((acE,i) => {
              acE.classList.remove('accordion__element_hover');
              console.log(acE.querySelector('img').getAnimations(), i);
            });
            el.classList.add('accordion__element_hover');
            statsOnWidgetInteraction(el, el.querySelector('.accordion__title').innerText);
          }
        });
      });
    });
  }
}
